import React from "react";
import Link from "next/link";
import { getDisplayName, multi } from "../utils/tools";
import millify from "millify";
import VoiceImage from "./VoiceImage";
import { FaStar } from "react-icons/fa";
import axios from "axios";
import { getAuth } from "firebase/auth";

const ModelCard2 = (props) => {
  const { model, index } = props;

  const isCollection = model.isCollection;

  const handleClick = async () => {
    try {
      const lastSearchId = sessionStorage.getItem("lastSearchId");
      if (!lastSearchId) return;

      // Get the auth token if user is logged in
      const auth = getAuth();
      const token = await auth.currentUser?.getIdToken();

      // Track the click
      await axios.post(
        "/api/search/c",
        { searchId: lastSearchId, modelId: model._id },
        { headers: token ? { Authorization: token } : undefined },
      );
    } catch (error) {
      // Continue with navigation even if tracking fails
    }
  };

  return isCollection ? (
    <Link
      key={model._id}
      style={{
        animationDelay: `${0.05 * index}s`,
      }}
      className="card-fade-in tw-h-64 tw-mb-2 tw-flex tw-justify-center tw-items-center t-w-full tw-overflow-visible tw-opacity-0 tw-relative  tw-shadow-xl tw-rounded-[26px]"
      href={`/collection/${model._id}`}
      onClick={handleClick}
    >
      <div className="tw-absolute tw-z-[5]  tw--bottom-3  tw-w-11/12 tw-h-full tw-bg-gray-400 tw-rounded-3xl" />
      <div className="tw-absolute  tw-z-[2] tw--bottom-6  tw-w-10/12 tw-h-full tw-bg-gray-300 tw-rounded-3xl" />
      <div className="tw-absolute  tw-z-[1] tw--bottom-9  tw-w-9/12 tw-h-full tw-bg-gray-200 tw-rounded-3xl" />

      <div className="tw-relative tw-w-full tw-h-full">
        <VoiceImage
          model={model}
          className="tw-rounded-[26px] tw-z-10"
          sizes="(max-width: 710px) 100vw,
              (max-width: 910px) 50vw,
              (max-width: 1200px) 33vw,
              (max-width: 1400px) 25vw,
              15vw"
          fill={true}
          style={{
            objectFit: "cover",
          }}
        />
        <div className="tw-absolute tw-z-10 tw-bottom-0 tw-left-0 tw-w-full tw-h-2/3 tw-bg-gradient-to-t tw-from-black tw-to-transparent tw-rounded-b-3xl" />
      </div>
      <div className="tw-w-full tw-h-full tw-text-white tw-z-20 tw-absolute tw-bottom-0 tw-p-3 tw-rounded-b-3xl tw-px-4">
        <div className="tw-flex tw-flex-col tw-h-full">
          <div className="tw-text-white tw-text-sm tw-w-full tw-font-black tw-tracking-widest tw-z-20 tw-bg-sky-400/80 tw-px-2 tw-w-max tw-p-1 tw-rounded-full tw-mb-auto">
            COLLECTION
          </div>
          <div className="tw-font-black tw-mt-auto tw-text-lg tw-text-white tw-truncate">
            {model.title}
          </div>
          <div className="tw-w-full tw-truncate tw-text-white/40 tw-font-black">
            <span className="tw-text-sm tw-text-white/80 tw-font-black tw-truncate">
              {millify(Math.round(model.modelsCount))} Voices ·{" "}
              {millify(Math.round(model.likes ?? 0))} Likes
              {model?.user?.username && ` · ${model?.user?.username}`}
            </span>
          </div>
        </div>
      </div>
    </Link>
  ) : (
    <Link
      key={model._id}
      style={{
        animationDelay: `${0.05 * index}s`,
      }}
      className="card-fade-in tw-overflow-visible tw-opacity-0 tw-relative tw-aspect-square tw-shadow-xl tw-rounded-[26px]"
      href={`/${model?.urlParam}`}
      onClick={handleClick}
    >
      <div className="tw-aspect-square tw-relative tw-w-full tw-h-full">
        <VoiceImage
          model={model}
          className="tw-rounded-[26px]"
          sizes="(max-width: 710px) 100vw,
                  (max-width: 910px) 50vw,
                  (max-width: 1200px) 33vw,
                  (max-width: 1400px) 25vw,
                  15vw"
          fill={true}
        />
      </div>
      <div className="tw-w-full tw-bg-white tw-absolute tw-bottom-0 tw-p-3 tw-rounded-b-3xl tw-px-4">
        <div className="tw-flex tw-flex-col">
          <div className="tw-font-bold tw-text-lg tw-text-black tw-flex tw-gap-1 tw-items-center">
            {model?.isCommunityFavorite && (
              <FaStar
                size={22}
                className="tw-text-amber-400 tw-z-10 tw--mt-1"
              />
            )}
            <span className="tw-truncate">{getDisplayName(model)}</span>
          </div>
          <div className="tw-w-full tw-truncate tw-text-black/40 tw-font-bold">
            <span className="tw-text-sm tw-text-black/40 tw-font-bold tw-truncate">
              {millify(Math.round(model.uses * multi))} Uses ·{" "}
              {millify(Math.round(model.likes ?? 0))} Likes
              {model?.user?.username && ` · ${model?.user?.username}`}
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ModelCard2;
